import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=faa355cc&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"
import style0 from "./Slides.vue?vue&type=style&index=0&id=faa355cc&scoped=true&lang=scss"
import style1 from "./Slides.vue?vue&type=style&index=1&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa355cc",
  null
  
)

export default component.exports